export enum MassiveProgramFlags {
  /** Activates the progress modal */
  CREATING_SERVICE,
  /** Enable the button to close the progress modal when something fail */
  SERVICE_FAIL,
  /** Activates the update route order modal */
  UPDATE_ROUTE_ORDER,
  /** Enable the button close the update route modal when somethign fail */
  UPDATE_ROUTE_ORDER_FAIL,
}
